<div bsModal #deleteModal="bs-modal" class="modal fade" [config]="{ keyboard: false, backdrop: 'static' }" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="myModalLabel">
                    Delete {{ state.EntityType | capitalize }} Confirmation
                </h4>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-12">
                        Are you sure you want to delete the {{ state.EntityType }}: {{ state.FriendlyName }}
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-warning" (click)="confirm()">Confirm Deletion</button>
                <button type="button" class="btn btn-primary" (click)="cancel()">Cancel</button>
            </div>
        </div>
    </div>
</div>